export const loginList = [
  {
    label: "GitHub",
    value: "github",
    icon: "icon-github",
    fontsize: "20px",
  },
  {
    label: "Google",
    value: "google",
    icon: "icon-google",
    fontsize: "17px",
  },
  {
    label: "Email",
    value: "email",
    icon: "icon-email",
    fontsize: "20px",
  },
  {
    label: "Microsoft",
    value: "microsoft",
    icon: "icon-microsoft",
    fontsize: "17px",
  },
];
